import HeroSection from "./HeroSection";
import RichTextSection from "./RichTextSection";
import AccordionSection from "./AccordionSection";
import ListSection from "./ListSection";
import CardsSection from "./CardsSection";
import DownloadsSection from "./DownloadsSection";
import GallerySection from "./GallerySection";
import ImageTextSection from "./ImageTextSection";
import QuoteSection from "./QuoteSection";
import SpacerSection from "./SpacerSection";
import DatasetsNewsTicker from "./NewsTickerSection";

const SECTION_COMPONENTS = {
  hero: HeroSection,
  rich_text: RichTextSection,
  accordion: AccordionSection,
  list: ListSection,
  cards: CardsSection,
  downloads: DownloadsSection,
  gallery: GallerySection,
  image_text: ImageTextSection,
  quote: QuoteSection,
  spacer: SpacerSection,
  news_ticker: DatasetsNewsTicker
};

function SectionRenderer({ section }) {
  if (!section || section.is_visible === false) return null;

  const Component = SECTION_COMPONENTS[section.section_type];

  if (!Component) {
    console.warn("Unknown section type:", section.section_type);
    return null;
  }

  return <Component section={section} />;
}

export default SectionRenderer;